export const soaStatusList = [
  {
    id: 1,
    name: 'Balance open',
    color: '#E98A46'
  },
  {
    id: 2,
    name: 'Payments completed',
    color: '#F63B3B'
  },
  {
    id: 3,
    name: 'Funds are consumed',
    color: '#04AB14'
  }
]



// WEBPACK FOOTER //
// ./src/constants/soaStatusList.js